export enum CHAT_GROUPS{
TODAY ="Today",
YESTERDAY = "Yesterday",
PREV_7_DAYS ="Previous 7 Days",
PREV_30_DAYS ="Previous 30 Days",
EARLIER = "Earlier"
}